type Platform = 'mac' | 'windows';

class SlideElementHotkey {
    // eslint-disable-next-line no-useless-constructor
    constructor(public readonly keys: string, public readonly mac: string[], public readonly windows: string[]) {}

    static getPlatform(navigatorObj: Navigator = navigator): Platform {
        return navigatorObj.userAgent.toLowerCase().includes('mac') ? 'mac' : 'windows';
    }

    getPlatformKeys(navigatorObj: Navigator = navigator): string[] {
        return SlideElementHotkey.getPlatform(navigatorObj) === 'mac' ? this.mac : this.windows;
    }

    getLabel(navigatorObj: Navigator = navigator): string {
        const keys = this.getPlatformKeys(navigatorObj);
        return keys.join('+');
    }
}

export const SlideElementHotkeys = {
    Duplicate: new SlideElementHotkey('meta+d, ctrl+d', ['⌘', 'D'], ['Ctrl', 'D']),
    Delete: new SlideElementHotkey('backspace, delete', ['Backspace'], ['Delete']),
    Save: new SlideElementHotkey('meta+s, ctrl+s', ['⌘', 'S'], ['Ctrl', 'S']),
    Export: new SlideElementHotkey('meta+e, ctrl+e', ['⌘', 'E'], ['Ctrl', 'E']),
    Import: new SlideElementHotkey('meta+i, ctrl+i', ['⌘', 'I'], ['Ctrl', 'I']),
    Copy: new SlideElementHotkey('meta+c, ctrl+c', ['⌘', 'C'], ['Ctrl', 'C']),
    Paste: new SlideElementHotkey('meta+v, ctrl+v', ['⌘', 'V'], ['Ctrl', 'V']),
    Cut: new SlideElementHotkey('meta+x, ctrl+x', ['⌘', 'X'], ['Ctrl', 'X']),
    Undo: new SlideElementHotkey('meta+z, ctrl+z', ['⌘', 'Z'], ['Ctrl', 'Z']),
    Redo: new SlideElementHotkey('meta+shift+z, ctrl+shift+z', ['⌘', '⇧', 'Z'], ['Ctrl', 'Shift', 'Z']),
    ElementText: new SlideElementHotkey('t', ['t'], ['t']),
    ElementTable: new SlideElementHotkey('shift+t', ['Shift', 'T'], ['Shift', 'T']),
    ElementQuestion: new SlideElementHotkey('shift+q', ['Shift', 'q'], ['Shift', 'q']),
    ElementYesNo: new SlideElementHotkey('shift+n', ['Shift', 'n'], ['Shift', 'n']),
    ElementMultiselect: new SlideElementHotkey('shift+m', ['Shift', 'm'], ['Shift', 'm']),
    ElementPhoto: new SlideElementHotkey('shift+p', ['Shift', 'p'], ['Shift', 'p']),
    ElementImageMarkup: new SlideElementHotkey('shift+i', ['Shift', 'i'], ['Shift', 'i']),
    ElementSequence: new SlideElementHotkey('shift+s', ['Shift', 's'], ['Shift', 's']),
    ElementMatchPair: new SlideElementHotkey('shift+x', ['Shift', 'x'], ['Shift', 'x']),
    ElementLikertScale: new SlideElementHotkey('shift+l', ['Shift', 'l'], ['Shift', 'l']),
    ElementLine: new SlideElementHotkey('l', ['l'], ['l']),
    ElementArrow: new SlideElementHotkey('shift+a', ['Shift', 'a'], ['Shift', 'a']),
    SidepanelSlideSettings: new SlideElementHotkey('tab', ['tab'], ['tab']),
};
